export const TYPE_TRANSPORT_MODE = {
  urb: "07.70",
  sub: "07.04",
  extraurb: "07.01",
};
